import { Redirect, Route, RouteProps } from 'react-router'

import { prependOrg, useOrganization } from '@signavio/effektif-api'
import { ComponentType } from 'react'

interface AdminRouteProps extends Omit<RouteProps, 'component'> {
  component: ComponentType<React.PropsWithChildren<Record<string, unknown>>>
}

function AdminRoute({
  component: Component,
  ...rest
}: AdminRouteProps): React.ReactNode {
  const organization = useOrganization()

  return (
    <Route
      {...rest}
      render={(props) => {
        const { location } = props

        if (!organization.admin) {
          return (
            <Redirect
              to={{
                pathname: prependOrg('/cases/tasks/inbox'),
                state: { from: location },
              }}
            />
          )
        }

        return <Component {...props} />
      }}
    />
  )
}

export default AdminRoute
